/* eslint-disable no-console */
import angular from 'angular';
import { NewSeatsMapService } from '../../../service/ib-new-seat-map-service';

const componentOptions = {
    bindings: {
        currency: '<',
        segment: '<',
        seatmapSegment: '<',
        slice: '<',
        passengerIndex: '<'
    },
    controllerAs: 'routePassengersInfoCtrl',
    templateUrl: [
        '$rootScope',
        function ($rootScope) {
            return $rootScope.routes.templates + 'ib-route-passengers-info.html';
        }
    ]
};

const componentInfo = {
    module: 'ib-route-passengers-info-module',
    selector: 'ibRoutePassengersInfo',
    inject: ['CurrencyService', '$filter', 'NewSeatsMapService', '$scope', '$rootScope'],
    required: []
};

export class IbRoutePassengersInfo implements angular.IController {

    public currency: any;
    public slice: any;
    public seatmapSegment: any;
    public openSliceCollapse: boolean = false;

    constructor (
        private SeatsMapService: NewSeatsMapService,
        private CurrencyService: CurrencyService,
        private $filter: ng.IFilterService,
        private $scope: angular.IScope,
        private $rootScope: CommonsRootScope
    ) {
        this.$rootScope.$on('loadRouteInfo', this.checkIsCurrentSlice);
    }


    $onInit (): void {
        if (this.slice.segments.length > 0) {
            this.checkIsCurrentSlice();
        }
    }

    $onChanges (onChangesObj: angular.IOnChangesObject): void {
        if (this.slice.segments.length > 0) {
            this.checkIsCurrentSlice();
        }
    }

    filterSegmentsToShow (): void {

    }

    checkIsCurrentSlice (): void  {
        this.openSliceCollapse = false;
        for(let i = 0; i < this.slice.segments.length; i++) {
            if(this.slice.segments[i].segmentInfo.id.toString() === this.seatmapSegment.segmentId.toString()) {
                this.openSliceCollapse = true;
            }
        }
    }

    toggleCollapse = (): any => {
        this.openSliceCollapse = !this.openSliceCollapse;
    };

    /**
     * Filter price
     * @param {*} price
     */
    filterCurrency = (price: any): any => {
        return price > 0 ? this.CurrencyService.formatPrice(this.currency, price, false, false) :this.$filter('translate')('CKIANCSEATS_FREE_PRICE');
    };

}

try {
    const mod = angular.module(componentInfo.module);
    IbRoutePassengersInfo.$inject = componentInfo.inject;
    mod.component(componentInfo.selector, angular.extend(componentOptions, { controller: IbRoutePassengersInfo }));
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    IbRoutePassengersInfo.$inject = componentInfo.inject;
    mod.component(componentInfo.selector, angular.extend(componentOptions, { controller: IbRoutePassengersInfo }));
}

